export const SCHEDULES_INIT = 'SCHEDULES_INIT'

export const SELECT_SCHEDULE = 'SELECT_SCHEDULE'

export const CHANGE_DATE_END = 'CHANGE_DATE_END'



// WEBPACK FOOTER //
// ./src/store/schedules/mutation-types.js